import React from 'react'
import imgNotFound from '../../../../icons/imgNotFound.png'

export const TemplateImg = ({ styles, classesWithTitle, classesWithOutTitle, url, title }) => {
  return (
    <div
      style={{ ...styles, backgroundImage: `url(${url || imgNotFound})`}}
      className={title ? classesWithTitle : classesWithOutTitle}
    />
  )
}
